import { render, staticRenderFns } from "./editAttachment.vue?vue&type=template&id=54541ba8"
import script from "./editAttachment.vue?vue&type=script&lang=js"
export * from "./editAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports